
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.434 4.923h-3.922c-1.189 0-1.98.002-2.568.081-.559.075-.783.203-.927.347-.144.144-.271.368-.347.927-.079.589-.08 1.38-.08 2.568v12.308c0 1.188.001 1.979.08 2.567.076.56.203.784.347.927.144.144.368.272.927.347.589.08 1.38.081 2.568.081h7.385c1.188 0 1.98-.002 2.567-.08.56-.076.784-.204.928-.348.143-.143.271-.367.346-.927.08-.588.082-1.379.082-2.567v-8.847H18.838c-.53 0-1.023 0-1.426-.053-.446-.06-.927-.203-1.324-.6-.397-.397-.54-.878-.6-1.324-.054-.403-.054-.896-.053-1.426V4.923zm7.2 5.384c-.06-.062-.139-.14-.242-.244L17.68 5.35a20.666 20.666 0 00-.245-.243v3.738c0 .608.002.964.036 1.217a.941.941 0 00.035.173c.027.01.08.023.173.035.253.034.609.036 1.217.036h3.738zM18.01 3.093c-.417-.173-.866-.171-1.263-.17H11.444c-1.102 0-2.029 0-2.766.1-.781.104-1.498.337-2.075.914-.577.577-.81 1.294-.915 2.075-.099.737-.099 1.664-.099 2.766V21.222c0 1.102 0 2.028.1 2.766.104.78.337 1.497.914 2.075.577.577 1.294.81 2.075.915.737.099 1.664.099 2.766.098H18.965c1.102 0 2.029 0 2.766-.099.781-.105 1.497-.337 2.075-.914.577-.578.81-1.294.915-2.075.099-.738.099-1.664.099-2.766V10.996c.001-.398.003-.846-.17-1.263-.173-.417-.491-.733-.773-1.013l-.071-.071-4.712-4.712-.071-.071c-.28-.282-.596-.6-1.013-.773zm-.528 7.132l.008.004-.008-.004zm.034.033a.047.047 0 00-.003-.006l.004.008v-.002z","fill":"#37F"}}),_c('path',{attrs:{"d":"M11 17.667L14.2 21l5.3-6","stroke":"#37F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    